<template lang="pug">
  section.testimonials
    img.testimonials__squiggle-left(v-lazy="squiggleLeft")
    img.testimonials__squiggle-right(v-lazy="squiggleRight")
    .testimonials__container
      .testimonials__content
        h2.testimonials__headline {{ headline }}
        transition(name="fade" mode="out-in")
          testimonial-quote(
            v-for="(quote, index) in quotes"
            :key="`${quote.name}__${index}__quote`"
            v-if="index === currentQuoteIndex"
            :quote="quote"
          )
        .testimonials__navigation
          button.testimonials__navigation-button(
            v-for="(quote, index) in quotes"
            :key="`${quote.name}__${index}__button`"
            :class="{ 'testimonials__navigation-button--active': currentQuoteIndex === index }"
            @click="currentQuoteIndex = index"
          )
            span.u-sr-only {{ "See " + quote.name + "'s testimonial" }}
            responsive-image.testimonials__navigation-button-image(:src="quote.profileImage")
      .testimonials__featured-image-container(v-if="['desktop', 'hd'].includes($mq)")
        transition(name="fade" mode="out-in")
          responsive-image.testimonials__featured-image(
            v-for="(quote, index) in quotes"
            v-if="currentQuoteIndex === index"
            :key="`${quote.name}__${index}__image`"
            aspect-ratio="429:520"
            :src="quote.featuredImage.src"
            :alt="quote.featuredImage.alt"
          )
</template>

<script>
  import ResponsiveImage from 'scripts/components/basic/ResponsiveImage.vue';
  import TestimonialQuote from 'scripts/components/sections/TestimonialQuote.vue';

  export default {
    components: {
      TestimonialQuote,
      ResponsiveImage,
    },
    props: {
      headline: String,
      squiggleLeft: String,
      squiggleRight: String,
      quotes: {
        type: Array,
        default: () => [
          {
            name: String,
            city: String,
            profileImage: String,
            featuredImage: {
              src: String,
              alt: String,
            },
            quote: String,
          },
        ],
      },
    },
    data() {
      return {
        currentQuoteIndex: 0,
      };
    },
  };
</script>

<style lang="scss">
  .testimonials {
    position: relative;
    margin: 40px auto;

    @include tablet-up {
      margin-bottom: 0;
    }
  }

  .testimonials__container {
    margin: 0 auto;
    max-width: 1150px;

    @include desktop-up {
      display: flex;
      margin: 0 auto 30px auto;
      padding: 0 30px;
    }
  }

  .testimonials__content {
    @include desktop-up {
      flex: 1;
      padding-right: 35px;
    }
  }

  .testimonials__headline {
    margin: 30px 0 4px 0;
    color: $color-green-900;
    font-size: $font-size-heading-6;
    font-family: $font-accent;
    line-height: rem(40);
    letter-spacing: 2px;
    text-align: center;

    @include desktop-up {
      text-align: left;
    }
  }

  .testimonials__navigation {
    display: flex;
    margin: 20px auto 25px auto;
    padding: 0 15px;
    align-items: flex-start;
    justify-content: center;

    @include desktop-up {
      margin: 50px auto 0 auto;
      justify-content: flex-start;
    }
  }

  .testimonials__navigation-button {
    outline: 0;
    padding: 8px;
    width: 25%;
    max-width: 81px;
    background-color: transparent;
    border: 1px solid transparent;
    border-radius: 50%;
    transition: 0.3s border-color;
    cursor: pointer;

    @include desktop-up {
      max-width: 128px;
    }

    &:nth-child(even) {
      margin-top: 25px;

      @include desktop-up {
        margin-top: 40px;
      }
    }

    &:focus,
    &:hover {
      border-color: $color-green-900;
    }
  }

  .testimonials__navigation-button--active {
    padding: 7px;
    border-color: $color-green-900;
    border-width: 2px;

    @include desktop-up {
      padding: 6px;
      border-width: 3px;
    }
  }

  .testimonials__navigation-button-image {
    border-radius: 50%;
    overflow: hidden;
  }

  .testimonials__featured-image {
    width: 429px;
  }

  .testimonials__squiggle-left {
    display: none;
    position: absolute;
    top: 20px;
    left: -45px;
    width: 200px;

    @include desktop-up {
      display: block;
    }
  }

  .testimonials__squiggle-right {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 105px;

    @include desktop-up {
      right: -15px;
      bottom: -60px;
      width: 195px;
    }
  }
</style>
